import { cloneElement, HTMLAttributes, ReactElement } from 'react';

import cx from 'classnames';

import { baselClassic, baselGrotesk, inter } from './fonts';
import { SkeletonProvider } from './Skeleton/SkeletonProvider';
import { GlossDSThemeProvider } from './ThemeProvider/ThemeProvider';

import tokens from './tokens.module.css';

type Props = {
  children: ReactElement<HTMLAttributes<HTMLElement>>;
  rebrand?: boolean;
};

export const GlossDS = ({ children, rebrand = false }: Props) => {
  return (
    <GlossDSThemeProvider
      className={cx(
        tokens.glossDS,
        rebrand && baselGrotesk.variable,
        rebrand && baselClassic.variable,
        rebrand && tokens.rebrand,
      )}
    >
      <SkeletonProvider>
        {cloneElement(children, {
          className: cx(
            inter.variable,
            tokens.glossDS,
            tokens.light,
            rebrand && tokens.rebrand,
            children.props.className,
          ),
        })}
      </SkeletonProvider>
    </GlossDSThemeProvider>
  );
};
